import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ceadb4e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ceadb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceadb4e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcoBtnCar: require('/app/components/svg/IcoBtnCar.vue').default,SvgArrowRight: require('/app/components/svg/ArrowRight.vue').default,SvgIcoBtnTruck: require('/app/components/svg/IcoBtnTruck.vue').default,SvgLogoThin: require('/app/components/svg/LogoThin.vue').default,SubNav: require('/app/components/SubNav.vue').default,Sticky: require('/app/components/Sticky.vue').default,AnimBottomToTop: require('/app/components/AnimBottomToTop.vue').default,Anchor: require('/app/components/Anchor.vue').default,SvgChevron: require('/app/components/svg/Chevron.vue').default})
